import { Menu, BMenuProps } from "../core/components/menu.js";
import { TreeView, TreeViewField } from "../core/components/treeView.js";
import { Config } from "../core/config/config.js";
import { Sheet } from "../../siteManagement/sheet.js";
import React from "react";

export class TabAndRouteSelection extends React.Component<TabAndRouteSelectionProps, any>{

    private _getMenuProps = (): BMenuProps => {
        return {
            entries: [
                {
                    text: Config.translations.select,
                    onClick: "select",
                    show: "selectEnabled"
                }
            ],
            onSelect: (e: any) => {
                if (e === "select") {
                    this.props.onSelect(this.state.selectedItem.connectionId, this.state.selectedItem.routeId);
                }
                else if (e === "x") {
                    if (this.props.windowRef)
                        this.props.windowRef.hide();//.close();
                }

            },
            enableMenuItem: (condition: any) => {
                return condition === "selectEnabled" ? this._isSelectEnabled() : true;
            },
            handleEval: null
        }
    }

    private _isSelectEnabled = () => {
        return (this.state != null && this.state.selectedItem != null);
    }

    private _createTreeViewField = () => {
        let field: TreeViewField = {
            model: "selectedNode",
            type: "treeView",
            dataSourceUrl: "Directions/GetTabAndRouteTree",
            dataTextField: ["name", "name"],
            imageUrlField: "image",
            cssClassField: "cssClassField",
            expand: true,
            schema: this._getSchema()
        };
        return field;
    }

    private _getSchema = () => {
        return {
            model: {
                id: "uId",
                children: "items"
            }
        };
    }

    onChange = (field: { model: string }, value: any, dataItem?: any) => {
        this.setState({ selectedItem: dataItem });
    }

    render() {
        let menuProps = this._getMenuProps();
        return (
            <div className="flex-container">
                <Menu {...menuProps} />
                <br />
                <TreeView onChange={this.onChange} field={this._createTreeViewField()} value={1}></TreeView>
            </div>)
    }
}

export interface TabAndRouteSelectionProps {
    windowRef?: Sheet;
    onSelect(tab: string, route: number): void;
}